import { METALS } from '~/scopes/campaign/data/metals/data'

/**
 * Resolve a metal by slug for an article's `metal` field. Lives apart from the
 * `index` aggregator so the per-article files can use it without importing the
 * aggregate that imports them back (avoids a circular dependency).
 */
export const articleMetal = (slug: string) => {
  const found = METALS.find((m) => m.slug === slug)
  if (!found) throw new Error(`Metal not found: ${slug}`)

  return found
}
